{
  "name": "codefend",
  "version": "3.2.0",
  "description": "Code obfuscator CLI that protects your code regardless of the programming language or framework.",
  "keywords": [
    "codefend",
    "obfuscator",
    "uglifier",
    "angular",
    "vue",
    "react",
    "svelte",
    "typescript",
    "css",
    "html",
    "python",
    "c#",
    "c++",
    "rollup",
    "webpack",
    "vite"
  ],
  "engines": {
    "node": ">=18.0.0"
  },
  "author": "Mounzer Adas",
  "homepage": "https://github.com/Codefend/core.git",
  "bugs": {
    "url": "https://github.com/Codefend/core/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Codefend/core.git"
  },
  "license": "MIT",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    "import": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "require": {
      "types": "./dist/index.d.cts",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist",
    "bin/**"
  ],
  "bin": {
    "codefend": "./bin/index.js"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsup",
    "format": "prettier --write \"src/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\"",
    "test": "vitest",
    "test:run": "vitest --run",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint src --ext .ts --fix",
    "lint:check": "eslint src --ext .ts",
    "spell:check": "cspell \"{README.md,CODE_OF_CONDUCT.md,CONTRIBUTING.md,.github/*.md,src/**/*.ts}\"",
    "type:check": "tsc --noEmit",
    "prepack": "npm run lint:check && npm run spell:check && npm run type:check && npm run test:run && npm run build"
  },
  "devDependencies": {
    "@types/node": "^22.4.0",
    "@typescript-eslint/eslint-plugin": "^8.1.0",
    "@typescript-eslint/parser": "^8.1.0",
    "cspell": "^8.14.1",
    "eslint": "^8.56.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "prettier": "^3.3.3",
    "tsup": "^8.2.4",
    "typescript": "^5.5.4",
    "vitest": "^2.0.5"
  },
  "dependencies": {
    "cli-table3": "^0.6.5"
  }
}
